/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPaymentDeviceCatalogRequest} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_payment_device_catalog.pb'
import {GetPaymentDeviceCatalogResponse} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/get_payment_device_catalog.pb'


export const getPaymentDeviceCatalog = (request: GetPaymentDeviceCatalogRequest, options?: CashRequestOptions) => post<GetPaymentDeviceCatalogRequest, GetPaymentDeviceCatalogResponse>("/cash-app/whimsicard/get-payment-device-catalog", request, {...options, rejectOnError: true })